module.exports = __webpack_public_path__ + "static/media/dummy-img.719cec5d.jpg";